import { Permission } from '../../api/roles.dao';
import { USER_PERMISSIONS } from '../../constants/permission.boilerplate';

const readStoredPermissions = (): { isSuperuser?: boolean; permissions?: Permission[] } =>
    JSON.parse(localStorage.getItem(USER_PERMISSIONS) ?? '{}');

const hasPermission = (permission: Permission): boolean => {
    const { isSuperuser, permissions } = readStoredPermissions();
    return isSuperuser || permissions?.includes(permission);
};

const hasAnyPermission = (requiredPermissions: Permission[]): boolean => {
    const { isSuperuser, permissions } = readStoredPermissions();
    return isSuperuser || requiredPermissions.some(permission => permissions?.includes(permission));
};

const isSuperUser = (): boolean => {
    const { isSuperuser } = readStoredPermissions();
    return isSuperuser;
};

export { hasAnyPermission, hasPermission, isSuperUser };